/**
 * ntc-ricerca-veicolo.js — «Trova i ricambi per la tua auto».
 *
 * ⭐ COME FILTRA. Sul negozio i filtri per tag delle collezioni NON sono attivi: provati,
 * `?filter.p.tag=` e `/collections/all/<tag>` tornano il catalogo intero. Quello che funziona
 * e' la RICERCA con la sintassi dei tag:
 *     /search?q=tag:"BMW Serie 3 E46"&type=product
 * Verificato contro i dati: 194/194, 42/42, 123/123, 17/17. Non e' un ripiego, e' l'unica
 * strada che filtra davvero — e non dipende da nessuna app.
 *
 * ⚠️ L'albero (marche → modelli → versioni) NON sta nell'HTML: si scarica da un file a parte
 * e resta in cache. Sono 13 KB che altrimenti pesavano su OGNI pagina, e questo negozio ha
 * gia' un problema di peso.
 *
 * ⚠️ Se il file non arriva, i menu restano spenti con un messaggio, invece di lasciare tre
 * tendine vuote che sembrano rotte.
 */
( function () {
  'use strict';

  function avvia( radice ) {
    var indirizzo = radice.getAttribute( 'data-albero' );
    var marca    = radice.querySelector( '[data-ntc="marca"]' );
    var modello  = radice.querySelector( '[data-ntc="modello"]' );
    var versione = radice.querySelector( '[data-ntc="versione"]' );
    var anno     = radice.querySelector( '[data-ntc="anno"]' );
    var bottone  = radice.querySelector( '[data-ntc="cerca"]' );
    var avviso   = radice.querySelector( '[data-ntc="avviso"]' );
    var mostraN  = radice.getAttribute( 'data-conteggi' ) === 'true';
    var albero = [];

    function svuota( sel, etichetta ) {
      sel.innerHTML = '';
      var o = document.createElement( 'option' );
      o.value = '';
      o.textContent = etichetta;
      sel.appendChild( o );
      sel.disabled = true;
    }

    function riempi( sel, voci, etichetta ) {
      svuota( sel, etichetta );
      voci.forEach( function ( v ) {
        var o = document.createElement( 'option' );
        o.value = v.t;                       // il TAG da cercare
        o.textContent = mostraN && v.c ? v.n + ' (' + v.c + ')' : v.n;
        sel.appendChild( o );
      } );
      sel.disabled = voci.length === 0;
    }

    /** La voce copre quell'anno? Chi non ha anni copre sempre.
     *  ⚠️ Il catalogo non ha gli anni dappertutto: nascondere le voci senza anni farebbe
     *  sembrare che il ricambio non esista. */
    function copre( v, a ) {
      if ( ! a ) { return true; }
      if ( ! v.da && ! v.a ) { return true; }
      if ( v.da && a < v.da ) { return false; }
      if ( v.a && a > v.a ) { return false; }
      return true;
    }

    /** Gli anni da mettere in tendina: quelli coperti da cio' che si e' gia' scelto. */
    function anniPossibili() {
      var m = trova( albero, marca.value );
      var mm = m ? trova( m.m, modello.value ) : null;
      var fonte = mm ? [ mm ].concat( mm.v || [] )
        : ( m ? [ m ].concat( m.m || [] ) : albero );
      var da = null, a = null;
      fonte.forEach( function ( v ) {
        if ( v.da && ( da === null || v.da < da ) ) { da = v.da; }
        if ( v.a && ( a === null || v.a > a ) ) { a = v.a; }
      } );
      var fuori = [];
      if ( da === null || a === null ) { return fuori; }
      for ( var y = a; y >= da; y-- ) { fuori.push( { t: String( y ), n: String( y ) } ); }
      return fuori;
    }

    function aggiornaAnni() {
      if ( ! anno ) { return; }
      var tenere = anno.value;
      var voci = anniPossibili();
      riempi( anno, voci, anno.getAttribute( 'data-vuoto' ) );
      if ( voci.some( function ( v ) { return v.t === tenere; } ) ) { anno.value = tenere; }
    }

    function annoScelto() {
      return anno ? parseInt( anno.value, 10 ) : 0;
    }

    function trova( elenco, tag ) {
      for ( var i = 0; i < elenco.length; i++ ) {
        if ( elenco[ i ].t === tag ) { return elenco[ i ]; }
      }
      return null;
    }

    // ⚠️ Il bottone si accende appena c'e' UNA scelta: cercare per sola marca e' legittimo
    // («fammi vedere tutto per BMW»), non si obbliga ad arrivare alla versione.
    function aggiorna() {
      bottone.disabled = ! marca.value;
    }

    function vai() {
      var tag = versione.value || modello.value || marca.value;
      if ( ! tag ) { return; }
      // ⛔ QUESTO SELETTORE NON RICORDAVA NIENTE. Chi sceglieva l'auto da «Che auto hai?»
      //    arrivava sulla pagina filtrata e trovava la barra in alto con le tendine vuote:
      //    la scelta spariva al primo clic. Si scrive nella STESSA memoria della barra
      //    (`ntc_auto`), che e' l'unico posto dove l'auto del cliente sta di casa.
      // ⚠️ Sta nel BROWSER del cliente, non sul server: e' una comodita' sua, non un dato
      //    nostro. Se il browser la blocca (finestra anonima), semplicemente non ricorda.
      try {
        var pezzi = [ marca, modello, versione ].map( function ( s ) {
          return s && s.value
            ? s.options[ s.selectedIndex ].textContent.replace( /\s*\(\d+\)\s*$/, '' ) : '';
        } ).filter( Boolean );
        window.localStorage.setItem( 'ntc_auto',
          JSON.stringify( { tag: tag, nome: pezzi.join( ' ' ) } ) );
      } catch ( e ) {}
      // ⭐ Si va alla COLLEZIONE della marca, ristretta col filtro del livello scelto:
      //    ha la barra dei filtri, l'ordinamento, le pagine e un testo che Google legge.
      //    La ricerca resta solo come ripiego, se la marca non ha una collezione.
      var m = trova( albero, marca.value );
      if ( m && m.h ) {
        var q = '';
        if ( versione.value ) {
          q = '?filter.p.m.custom.versione_auto=' + encodeURIComponent( versione.value );
        } else if ( modello.value ) {
          q = '?filter.p.m.custom.modello_auto=' + encodeURIComponent( modello.value );
        }
        window.location.href = '/collections/' + m.h + q;
        return;
      }
      window.location.href = '/search?q=' + encodeURIComponent( 'tag:"' + tag + '"' ) +
        '&type=product&options%5Bprefix%5D=last';
    }

    function riempiModelli() {
      var m = trova( albero, marca.value );
      var a = annoScelto();
      var tenere = modello.value;
      riempi( modello, m ? ( m.m || [] ).filter( function ( x ) { return copre( x, a ); } ) : [],
              modello.getAttribute( 'data-vuoto' ) );
      if ( tenere ) { modello.value = tenere; }
    }

    function riempiVersioni() {
      var m = trova( albero, marca.value );
      var mm = m ? trova( m.m, modello.value ) : null;
      var a = annoScelto();
      var tenere = versione.value;
      riempi( versione, mm ? ( mm.v || [] ).filter( function ( x ) { return copre( x, a ); } ) : [],
              versione.getAttribute( 'data-vuoto' ) );
      if ( tenere ) { versione.value = tenere; }
    }

    marca.addEventListener( 'change', function () {
      svuota( versione, versione.getAttribute( 'data-vuoto' ) );
      riempiModelli();
      aggiornaAnni();
      aggiorna();
    } );

    modello.addEventListener( 'change', function () {
      riempiVersioni();
      aggiornaAnni();
      aggiorna();
    } );

    versione.addEventListener( 'change', aggiorna );
    if ( anno ) {
      anno.addEventListener( 'change', function () {
        riempiModelli();
        riempiVersioni();
        aggiorna();
      } );
    }
    bottone.addEventListener( 'click', vai );
    radice.addEventListener( 'keydown', function ( e ) {
      if ( e.key === 'Enter' && ! bottone.disabled ) { vai(); }
    } );

    svuota( modello, modello.getAttribute( 'data-vuoto' ) );
    svuota( versione, versione.getAttribute( 'data-vuoto' ) );

    fetch( indirizzo, { credentials: 'omit' } )
      .then( function ( r ) {
        if ( ! r.ok ) { throw new Error( 'HTTP ' + r.status ); }
        return r.json();
      } )
      .then( function ( d ) {
        albero = d || [];
        riempi( marca, albero, marca.getAttribute( 'data-vuoto' ) );
        aggiornaAnni();
        aggiorna();
      } )
      .catch( function () {
        // ⛔ Meglio dirlo che lasciare tre tendine vuote che sembrano rotte.
        if ( avviso ) {
          avviso.hidden = false;
          avviso.textContent = 'Elenco veicoli non disponibile in questo momento.';
        }
      } );
  }

  function tutte() {
    document.querySelectorAll( '[data-ntc-ricerca-veicolo]' ).forEach( avvia );
  }

  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', tutte );
  } else {
    tutte();
  }
  // ⚠️ Nell'editor del tema la sezione viene ricaricata da sola: senza questo, dopo ogni
  // modifica i menu restano morti finche' non si ricarica la pagina a mano.
  document.addEventListener( 'shopify:section:load', function ( e ) {
    var r = e.target.querySelector( '[data-ntc-ricerca-veicolo]' );
    if ( r ) { avvia( r ); }
  } );
}() );
